module.exports = "https://drv7djjgp3j3.cloudfront.net/f14feaec-818c-4d31-af5e-fd46c35896d3/images/logo_123travel.png?81d92fe2eace40c100da7ef2b0d1da59";